import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ForwardIcon from '@mui/icons-material/ArrowForwardIos';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import React, { useContext } from 'react';
import {useState} from 'react'
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import ENDPOINT from '../../context/EndPoint'

import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { MoreVert, PictureAsPdf } from '@material-ui/icons';
import { VideoFile } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
const InternalChaptersManagement = () => {
const params = useParams();
const course_url = params.course_url;
const [chapters,setchapters] = useState(null)
const {user} = useContext(AuthContext)
const dispatch = useDispatch()




const getChapters = async (status,) => {
  dispatch({ type: 'LOADING' });

  const formData = new FormData();
  formData.append('session', user.SessionId);
  formData.append('course_url', course_url);

  try {
    const res = await axios.post(
      ENDPOINT + "admin-get-chapters.php",
      formData,
      {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
    );

    if (res) {
      if (res.data.status === "success") {
        dispatch({ type: 'DONE_LOADING' });
        setchapters(res.data.data);
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: res.data.message || 'Failed to fetch chapters' 
        });
      }
    }
  } catch (error) {
    dispatch({ 
      type: 'ERROR', 
      payload: error.message || 'An error occurred while fetching chapters' 
    });
  }
};





const addChapter = async (status) => {
  dispatch({ type: 'LOADING' });

  const formData = new FormData();
  formData.append('session', user.SessionId);
  formData.append('course_url', course_url);
  formData.append('chapter_title', ctitle);
  formData.append('chapter_id', currentchapter);

  try {
    const res = await axios.post(
      ENDPOINT + "admin-add-chapter.php",
      formData,
      {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
    );

    if (res) {
      if (res.data.status === "success") {
        dispatch({ type: 'DONE_LOADING' });
        setctitle(null);
        setcurrentchapter(null);
        getChapters(); // Assuming this is the previously defined function
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: res.data.message || 'Failed to add chapter' 
        });
      }
    }
  } catch (error) {
    dispatch({ 
      type: 'ERROR', 
      payload: error.message || 'An error occurred while adding chapter' 
    });
  }
};
     
const [edit,setedit] = useState(false)
const [ctitle,setctitle] = useState(null);
const [currentchapter,setcurrentchapter] = useState(null)

useEffect(()=>{

getChapters();
},[])








const deleteChapter = async ({ url, chapter }) => {
  dispatch({ type: 'LOADING' });

  const formData = new FormData();
  formData.append('session', user.SessionId);
  formData.append('course_url', url);
  formData.append('chapter_id', chapter);

  try {
    const res = await axios.post(
      ENDPOINT + "admin-delete-chapter.php",
      formData,
      {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
    );

    if (res) {
      if (res.data.status === "success") {
        dispatch({ type: 'DONE_LOADING' });
        getChapters(); // Assuming this is the previously defined function
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: res.data.message || 'Failed to delete chapter' 
        });
      }
    }
  } catch (error) {
    dispatch({ 
      type: 'ERROR', 
      payload: error.message || 'An error occurred while deleting chapter' 
    });
  }
};
     

useEffect(()=>{

getChapters();
},[])








const style = {
     position: 'absolute',
     top: '50%',
     left: '50%',
     transform: 'translate(-50%, -50%)',
     width: 400,
     bgcolor: 'background.paper',
     border: '2px solid #000',
     boxShadow: 24,
     pt: 2,
     px: 4,
     pb: 3,
   };
   







  return (
<>

<div className="container-fluid sm-p-15 mt-3">





<Modal
  open={edit}
  onClose={()=>setedit(false)}
  aria-labelledby="parent-modal-title"
  aria-describedby="parent-modal-description"
>
  <Box sx={{ ...style, width: 500 }}>
  <p>Title  :</p>
    <input className="form-control"  value={ctitle} onChange={(e)=>{setctitle(e.target.value)}}></input>
    <br/>
    <p>Chapter No:</p>
    <input className="form-control" value={currentchapter} onChange={(e)=>{setcurrentchapter(e.target.value)}}></input>
    
   
 
<button className="btn btn-primary w-100 mt-3" onClick={addChapter}>Update Topic</button>
  </Box>
</Modal>












<div className="flex-wrap d-flex justify-content-between">

<h1>Chapter management</h1>

     <button className="btn btn-primary h-fit" onClick={()=>{setedit(true)}}>Add Chapter</button>
     
     
     </div>

<hr></hr>

<div className="container-fluid">

<div className=" d-flex flex-wrap">

     
{chapters?



<>

{chapters.map((chapter)=>(

<>


<div class="col-lg-4 p-2">


  <div class="shadow rounded p-3 hover-active">
        <div class="d-flex justify-content-between">
          <Link  to={"/course-management/"+course_url+"/chapters/"+chapter.chapter_id}>
          <h6 class="text-primary">{chapter.chapter_id}.{chapter.chapter_title}</h6>
          </Link>
  
            <Dropdown className="options-dropdown">
                <Dropdown.Toggle className="bg-white options p-0 w-fit h-fit  border-0">
                  <MoreVert className="text-dark"/>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item  onClick={()=>{setctitle(chapter.chapter_title);setcurrentchapter(chapter.chapter_id);setedit(true)}}><EditIcon className="mr-2"/>Edit</Dropdown.Item>
                  <Dropdown.Item  onClick={()=>deleteChapter({url:course_url,chapter:chapter.chapter_id})}  ><DeleteIcon className='mr-2'/> Delete</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
        <VideoFile/>Total videos : {chapter.total_videos}<br/>
        <PictureAsPdf className='m-1'/>Total Files : {chapter.total_files}
    </div>

   
  </div>


</>


))}

</>
:"no chapters"}


</div>

















</div>












</div>

</>

  )
};

export default InternalChaptersManagement;
